import {Component, EventEmitter, Input, Output} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators
} from '@angular/forms';
import {Router} from '@angular/router';
import { SelectableSettings } from '@progress/kendo-angular-grid';
import { SortDescriptor, orderBy } from '@progress/kendo-data-query';
import {Subscription} from "rxjs";

@Component({
  selector: 'app-picklist',
  templateUrl: './picklist-form.component.html',
  styleUrls: ['./picklist-form.component.scss']
})

export class PicklistFormComponent {
  @Input() firstSelectorList: any = [];
  @Input() secondSelectorList: any = [];
  @Input() currentAssigned: any = [];
  @Input() currentAvailable: any = [];
  @Input() firstSelectorActive: boolean = true;
  @Input() secondSelectorActive: boolean = true;
  @Input() firstLabelName: string = '';
  @Input() secondLabelName: string = '';
  @Input() field: any = '';
  @Input() parentGridChange: boolean = false;
  @Output() firstSelectorResults = new EventEmitter<any>();
  @Output() secondSelectorResults = new EventEmitter<any>();
  @Output() formUpdated = new EventEmitter<any>();
  @Output() formResults = new EventEmitter<any>();
  pickListForm: FormGroup;
  formChanges = new Subscription();
  assignedSelected: any[] = [];
  availableSelected: any[] = [];
  gridChanged: boolean = false;

  constructor(private formBuilder: FormBuilder, private _router: Router){
  }

  ngOnInit(): void {
    this.assignedSelected = [];
    this.availableSelected = [];
    if(this.secondSelectorActive) {
      this.pickListForm = this.formBuilder.group({
        firstSelector: new FormControl('', Validators.required),
        secondSelector: new FormControl('', Validators.required),
      });
    } else {
      this.pickListForm = this.formBuilder.group({
        firstSelector: new FormControl('', Validators.required),
      });
    }
  }

  firstSelectorValueChange(e): void {
    this.availableSelected = [];
    this.assignedSelected = [];
    this.firstSelectorResults.emit(e);
    this.gridChanged = false;
  }

  secondSelectorValueChange(e): void {
    this.availableSelected = [];
    this.assignedSelected = [];
    this.secondSelectorResults.emit(e);
    this.gridChanged = false;
  }

  addClicked(e): void {
    this.gridChanged = true;
    this.availableSelected.forEach((field) => {
      const object = this.currentAvailable.find((item) => item.name === field);
      const index = this.currentAvailable.findIndex((object) => object.name === field);
      this.currentAssigned.push(object);
      this.currentAvailable.splice(index, 1);
    });
    this.availableSelected = [];
    this.assignedSelected = [];
  } 
 
  addAllClicked(e): void {
    this.gridChanged = true;
    if(this.currentAvailable) {
      this.currentAvailable.forEach((item) => {
        this.currentAssigned.push(item);
      });
    }
    this.currentAvailable.length = 0;
    this.assignedSelected = [];
    this.availableSelected = [];
  }

  removeClicked(e): void {
    this.gridChanged = true;
    this.assignedSelected.forEach((field) => {
      const object = this.currentAssigned.find((item) => item.name === field);
      const index = this.currentAssigned.findIndex((object) => object.name === field);
      this.currentAvailable.push(object);
      this.currentAssigned.splice(index, 1);
    });
    this.assignedSelected = [];
    this.availableSelected = [];
  }
 
  removeAllClicked(e): void {
    this.gridChanged = true;
    if(this.currentAssigned) {
      this.currentAssigned.forEach((item) => {
        this.currentAvailable.push(item);
      })
    }
    this.currentAssigned.length = 0;
    this.assignedSelected = [];
    this.availableSelected = [];
  }

  onSubmit(): void {
    this.gridChanged = false;
    const values = this.currentAssigned;
    this.formResults.emit(values);
    this.availableSelected = [];
    this.assignedSelected = [];
  }

  public selectableSettings: SelectableSettings = {
    enabled: false,
    mode:'multiple'
  };

  public selectedCallback = (args) => args.dataItem;

  keyChangeAdd(event){
    this.availableSelected = event
  }

  keyChangeRemove(event){
    this.assignedSelected = event
  }

}
